import { createI18n } from "vue-i18n";
import * as en from "./en.json";
import * as zh from "./zh.json";
import * as ko from "./ko.json";
import * as zh_tw from "./zh-tw.json";
import * as pt from "./pt.json";
import * as ru from "./ru.json";
import * as ja from "./ja.json";
import * as th from "./th.json";
export const localStorageKey = "language";
export type Language = "zh" | "en" | "ko" | "zh_tw" | "pt" | "ru" | "ja" | "th";
export const languages = [
  {
    name: "中文",
    value: "zh",
  },
  {
    name: "中文繁体",
    value: "zh_tw",
  },
  {
    name: "English",
    value: "en",
  },
  {
    name: "한국인",
    value: "ko",
  },
  {
    name: "Português",
    value: "pt",
  },
  {
    name: "Русский",
    value: "ru",
  },
  {
    name: "日本語",
    value: "ja",
  },
  {
    name: "ภาษาไทย",
    value: "th",
  },
] as { name: string; value: Language }[];
const i18n = createI18n({
  locale: "zh",
  fallbackLocale: "en",
  messages: {
    en,
    zh,
    ko,
    zh_tw,
    pt,
    ru,
    ja,
    th,
  },
});

export const updateLanguage = (language: string) => {
  localStorage.setItem(localStorageKey, language);
  language = language.replace("-", "_");
  const lowerLanguage = language.toLocaleLowerCase();
  const lang = languages.find(
    (lang) => lang.value.toLocaleLowerCase() === lowerLanguage
  );
  if (lang) {
    i18n.global.locale = lang.value as Language;
  } else {
    const la = lowerLanguage.split("_");
    if (la.length > 0) {
      const fd = languages.find(
        (lang) => lang.value.toLocaleLowerCase() === la[0]
      );
      if (fd) {
        i18n.global.locale = fd.value as Language;
      } else {
        i18n.global.locale = i18n.global.fallbackLocale as Language;
      }
    } else {
      i18n.global.locale = i18n.global.fallbackLocale as Language;
    }
  }
};

export let isLangFromStorage = false;

const initLanguage = async () => {
  let local = localStorage.getItem(localStorageKey);
  if (!local) {
    local = navigator.language;
  } else {
    isLangFromStorage = true;
  }
  updateLanguage(local);
};

initLanguage();

export default i18n;
